module.exports = __webpack_public_path__ + "img/tebrikler-231.daadd42b.png";